import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IDoubleChanceConfig from "../src/server/interface/IDoubleChanceConfig";


class DoubleChanceConfig implements IDoubleChanceConfig {
    type: ConfigurationTypes = ConfigurationTypes.GAME_SPECIFIC;

    public scatterBoostCreditsPerBet: number;
    public scatterBoostRtp: number;
    public parseConfig(data: any) {

        if (data?.config?.creditsPerBet) {
            this.scatterBoostCreditsPerBet = data.config.creditsPerBet[1];
        }

        if (data?.config?.scatterBoostRtp) {
            this.scatterBoostRtp = data.config.scatterBoostRtp * 100;
        }
    }
}

export default new DoubleChanceConfig()
